// poiOverrideBus.ts
// =================
//
// Wave 14ce: Session-scoped Override für POI-Sichtbarkeit.
//
// Use-Case: User klickt im SOS-Screen "Bike defekt → show bike shops on map".
// Wir wollen alle POI-Kategorien ausser bike_shop temporär ausblenden, damit
// die Karte gefiltert auf Werkstätten/Rental-Shops zeigt — ohne die
// persistenten User-Toggles (localStorage) zu zerschiessen.
//
// Persistenz-Modell (User-Wunsch Option b):
//   - In-Memory only, kein localStorage / sessionStorage. Bei jedem App-
//     Reload ist der Override automatisch weg → User landet wieder auf
//     seinen normalen POI-Settings.
//   - Programmatisch lässt sich der Override aber jederzeit clearen
//     (`set(null)`), z.B. wenn der User selber das POI-Panel öffnet und
//     was anderes toggelt.

export type PoiOverrideMode = null | 'bike-only';

type Listener = (mode: PoiOverrideMode) => void;

class PoiOverrideBus {
  private current: PoiOverrideMode = null;
  private readonly listeners = new Set<Listener>();

  get(): PoiOverrideMode {
    return this.current;
  }

  set(mode: PoiOverrideMode): void {
    if (mode === this.current) return;
    this.current = mode;
    for (const l of this.listeners) l(mode);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const poiOverrideBus = new PoiOverrideBus();
